import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Layout } from './Home';
import PageHero from '../components/PageHero';
import RichContent from '../components/RichContent';
import { getAbout, resolveFileUrl } from '../services/api';

const AboutPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAbout()
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      {loading || !data ? (
        <div className="bg-[#e2ede6] py-32 text-center text-[#0b1a2e]/60">
          <Loader2 className="w-6 h-6 animate-spin inline mr-2" /> Loading…
        </div>
      ) : (
        <>
          <PageHero
            eyebrow="About Emerald Corporates"
            title={data.hero_title}
            description={data.hero_subtitle}
            image={
              resolveFileUrl(data.hero_image) ||
              'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1600&q=80'
            }
          />
          <section className="bg-[#e2ede6] py-16 lg:py-24" data-testid="about-page">
            <div className="max-w-6xl mx-auto px-6 lg:px-8 space-y-16 lg:space-y-24">
              {data.sections?.map((s) => {
                const hasImg = s.image_position !== 'none' && s.image_url;
                if (!hasImg) {
                  return (
                    <div
                      key={s.id}
                      data-testid="about-section"
                      className="bg-white rounded-2xl border border-black/5 p-6 lg:p-10 shadow-sm max-w-3xl mx-auto"
                    >
                      <h2
                        className="text-3xl lg:text-4xl text-[#0b1a2e] mb-6 border-l-4 border-[#0f5c3d] pl-4"
                        style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                      >
                        {s.heading}
                      </h2>
                      <RichContent text={s.body} />
                    </div>
                  );
                }
                const imgLeft = s.image_position === 'left';
                return (
                  <div
                    key={s.id}
                    data-testid="about-section"
                    className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${imgLeft ? '' : ''}`}
                  >
                    <div className={imgLeft ? 'lg:order-1' : 'lg:order-2'}>
                      <img
                        src={resolveFileUrl(s.image_url)}
                        alt={s.heading}
                        className="w-full rounded-2xl object-cover aspect-[4/3] shadow-lg"
                      />
                    </div>
                    <div className={imgLeft ? 'lg:order-2' : 'lg:order-1'}>
                      <h2
                        className="text-3xl lg:text-4xl text-[#0b1a2e] mb-6 border-l-4 border-[#0f5c3d] pl-4"
                        style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                      >
                        {s.heading}
                      </h2>
                      <RichContent text={s.body} />
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        </>
      )}
    </Layout>
  );
};

export default AboutPage;
